import { useEffect } from 'react';

// Kebab menus and dropdowns close when the user clicks anywhere outside them.
// Using `pointerdown` instead of `click` so we close BEFORE the target's own
// click handler fires — important when the click target is itself a button
// that should not also be interpreted as "open another menu".
export function useClickOutside<T extends HTMLElement>(
  ref: React.RefObject<T>,
  active: boolean,
  onOutside: () => void,
): void {
  useEffect(() => {
    if (!active) return;
    function handler(e: PointerEvent): void {
      if (!ref.current) return;
      if (!(e.target instanceof Node)) return;
      if (!ref.current.contains(e.target)) onOutside();
    }
    document.addEventListener('pointerdown', handler, true);
    return () => document.removeEventListener('pointerdown', handler, true);
  }, [ref, active, onOutside]);
}
